export default __webpack_public_path__ + "strongher-second-screens_small.e3014206.png";